import type { DraftSectionKey, PersonalSheetCompleteness } from "@/features/self/personal-sheet";

export interface DerivedCompleteness {
  completedSections: string[];
  completedCount: number;
  totalSections: number;
  progressPercent: number;
  allSectionsComplete: boolean;
}

export function fromDraftSectionKey(key: DraftSectionKey): string {
  return key === "emergency_contacts" ? "emergency" : key;
}

export function deriveCompleteness(
  completeness: PersonalSheetCompleteness | null,
  fallbackTotal: number,
): DerivedCompleteness {
  if (!completeness) {
    return {
      completedSections: [],
      completedCount: 0,
      totalSections: fallbackTotal,
      progressPercent: 0,
      allSectionsComplete: false,
    };
  }
  return {
    completedSections: completeness.sections.filter((s) => s.complete).map((s) => fromDraftSectionKey(s.id)),
    completedCount: completeness.completed_count,
    totalSections: completeness.total,
    progressPercent: completeness.percent,
    allSectionsComplete: completeness.can_complete,
  };
}
